var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5736 8.82467L8.48223 7.25611V4.06094C8.48223 3.73967 8.22254 3.47998 7.90127 3.47998C7.58 3.47998 7.32031 3.73967 7.32031 4.06094V7.54662C7.32031 7.72961 7.4063 7.90217 7.5527 8.01139L9.87646 9.75423C9.97675 9.82975 10.0989 9.87054 10.2245 9.87042C10.4016 9.87042 10.5759 9.79082 10.6898 9.63745C10.8827 9.38122 10.8304 9.01697 10.5736 8.82467Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90039 0C3.76464 0 0.400391 3.36425 0.400391 7.5C0.400391 11.6358 3.76464 15 7.90039 15C12.0361 15 15.4004 11.6358 15.4004 7.5C15.4004 3.36425 12.0361 0 7.90039 0ZM7.90039 13.8381C4.40601 13.8381 1.56228 10.9944 1.56228 7.5C1.56228 4.00562 4.40601 1.16188 7.90039 1.16188C11.3954 1.16188 14.2385 4.00562 14.2385 7.5C14.2385 10.9944 11.3948 13.8381 7.90039 13.8381Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeSub);
export default __webpack_public_path__ + "static/media/icon_time_sub.65e6a1a2d3f728582f2182f5fe755fae.svg";
export { ForwardRef as ReactComponent };